import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IIcon } from '../icon/icon.component';

@Component({
  selector: 'i2g-empty-state',
  templateUrl: 'empty-state.component.html',
  styleUrls: ['empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent implements OnInit {
  @Input() icon: IIcon;
  @Input() title: string;
  @Input() description: string;

  /**
   * TODO: add more features of empty state. Refer to SPA, such as
   * - Premium icon
   * - Router link
   */

  constructor() {}

  ngOnInit() {}
}
